import React, {Component} from "react"
import {Link, withRouter} from "react-router-dom"
import {Button, Icon} from "semantic-ui-react"
import shop from "shop/shop"
import FormCMS from "components/Form/FormCMS"

@withRouter
export default class CustomerEnablingPage extends Component {

  render() {
    return (
      <div>
        <div className="pa3">
          <Button as={Link} to="/login"><Icon name="chevron left"/>{translate("back to login")}</Button>
        </div>
        <div className="mw7 center pt2 pb6">

          <div className="tc pb4">
            <Link to="/login">
              <img src={shop.config.logo} title="Zur Startseite"/>
            </Link>
          </div>

          <FormCMS slug={"customer_enabling"} onSuccess={() => {
            this.props.history.push( "/login" )
            window.swal( "Anmeldung erhalten", "Vielen Dank für Ihre Anmeldung. Sie erhalten Ihre Anmeldedaten per E-Mail",
              "success" )
          }}/>
        </div>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/pages/CustomerEnablingPage.js